export const phoneFields = ["PHONE", "PHONE01", "PHONE02", "CCCPHONE01", "CCCPHONE02"];
